
import React, { useState,useEffect} from "react";

const documents = [
 
  {
    id: 6,
    category: "Publication Report",
    title: "Empowering Future Talents",
    description: "A Journey with Dereja",
    image: "/assets/bg.png",
    link: "/PDF/Empowering_Future_Talent.pdf",
  },
 
  {
    id: 1,
    category: "Publication Report",
    title: "2020-2023 Publication Report",
    description: "An overview of Dereja’s knowledge management initiatives, strategies, and systems aimed at capturing, organizing, and sharing institutional learnings.",
    image: "/assets/knowledegmanagment.png",
    link: "/PDF/ProgramReports/DerejaKnowledgeManagementandPublications20202023.pdf",
  },
{
  id: 11,
  category: "Impact Reports",
  title: "Dereja Program Brochure",
  description: "A snapshot of Dereja’s mission, key programs, and services supporting youth employability and career growth.",
  image: "/assets/brocher.png",
  link: "/PDF/ProgramReports/DerejaBrochure.pdf",
},
{
  id: 13,
  category: "Impact Reports",
  title: "2022 Dereja Booklet",
  description: "A summary of Dereja’s 2022 interventions, impact stories, and outreach efforts across various universities and regions.",
  image: "/assets/booklet2023.png",
  link: "/PDF/ProgramReports/2022Derejabooklet.pdf",
},
   {
  id: 12,
  category: "Impact Reports",
  title: "2023 Dereja Booklet",
  description: "A comprehensive booklet highlighting Dereja’s achievements, partnerships, and milestones throughout 2023.",
  image: "/assets/booklet.png",
  link: "/PDF/ProgramReports/2023DerejaBookletFinal.pdf",
},
{
  id: 8,
  category: "Impact Reports",
  title: "Unlock Your Next Chapter",
  description: "An inspirational report reflecting Dereja’s role in guiding graduates toward career readiness and opportunities.",
  image: "/assets/img15.jpg",
  link: "/PDF/ProgramReports/Unlockyournextchapter.pdf",
}, 
];

export default function Brochure() {
  useEffect(() => {
        window.scrollTo(0, 0); 
      }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const itemsPerPage = 6;

  
  const filteredDocs = documents.filter((doc) =>
    doc.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    doc.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredDocs.length / itemsPerPage);
  const startIndex = page * itemsPerPage;
  const paginatedDocs = filteredDocs.slice(startIndex, startIndex + itemsPerPage);

  const handleNext = () => {
    if (page < totalPages - 1) setPage(page + 1);
  };

  const handlePrev = () => {
    if (page > 0) setPage(page - 1);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setPage(0); 
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold text-orange mb-6 text-center">
        Knowledge Management Library
      </h1>

      <div className="max-w-2xl mx-auto mb-8">
        <input
          type="text"
          placeholder="Search documents..."
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400"
          onChange={handleSearch}
          value={searchTerm}
        />
        <p className="text-sm text-gray-600 mt-2">
          {filteredDocs.length > 0
            ? `Showing ${startIndex + 1}-${Math.min(
                startIndex + paginatedDocs.length,
                filteredDocs.length
              )} of ${filteredDocs.length} documents`
            : `No results found for "${searchTerm}"`}
        </p>
      </div>

      {filteredDocs.length > 0 ? (
        <>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
            {paginatedDocs.map((doc) => (
              <div
                key={doc.id}
                className="bg-white rounded-xl shadow hover:shadow-md p-4"
              >
                <img
                  src={doc.image}
                  alt={doc.title}
                  className="h-40 w-full object-cover rounded-md mb-4"
                />
                <h3 className="text-lg font-semibold text-gray-800">
                  {doc.title}
                </h3>
                <p className="text-sm text-gray-600">{doc.description}</p>
                <a
                  href={doc.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-block text-orange-600 hover:underline text-sm"
                >
                  View Document
                </a>
              </div>
            ))}
          </div>

          <div className="flex justify-center gap-4">
            <button
              onClick={handlePrev}
              disabled={page === 0}
              className={`px-4 py-2 rounded-md font-semibold ${
                page === 0
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-orange text-white hover:bg-orange-600"
              }`}
            >
              Previous
            </button>
            <button
              onClick={handleNext}
              disabled={page >= totalPages - 1}
              className={`px-4 py-2 rounded-md font-semibold ${
                page >= totalPages - 1
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-orange text-white hover:bg-orange-600"
              }`}
            >
              Next
            </button>
          </div>
        </>
      ) : (
        <div className="text-center text-gray-500 text-lg mt-20">
          📄 No documents match your search.
        </div>
      )}
    </div>
  );
}
